import { Button, Stack } from '@mui/material';
import { PlusIcon } from '@phosphor-icons/react';
import { type FlowHumanTaskBlock, FlowHumanTaskType } from 'flow-schema';

import { HumanTaskWorkContext } from './WorkContext';
import { useReactFlowViewContext } from '../../../../context/context';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';
import { getDefaultHumanTaskWorkContextConfig } from '../Steps/utils';

export function HumanTaskWorkContextTabs() {
  const { value: taskType } =
    useSelectedNodeField<FlowHumanTaskBlock['config']['taskType']>('config.taskType');

  const { value: workContexts = [], setValue } =
    useSelectedNodeField<FlowHumanTaskBlock['config']['workContexts']>('config.workContexts');
  const { isEditable } = useReactFlowViewContext();

  return (
    <Stack gap={4}>
      {workContexts.map((workContext, index) => {
        return (
          <HumanTaskWorkContext
            key={workContext.id}
            fieldNamePrefix={`config.workContexts.${index}`}
            workContextIndex={index}
            onDelete={
              workContexts.length > 1
                ? () => {
                    setValue(workContexts.filter((value) => value.id !== workContext.id));
                  }
                : undefined
            }
          />
        );
      })}
      {taskType !== FlowHumanTaskType.SubmitPriorAuthorization && (
        <Button
          variant="contained"
          onClick={() => {
            setValue([...workContexts, getDefaultHumanTaskWorkContextConfig()]);
          }}
          sx={{ alignSelf: 'flex-start', gap: 1 }}
          disabled={!isEditable}
        >
          <PlusIcon size={12} />
          Add a tab
        </Button>
      )}
    </Stack>
  );
}
